export default __webpack_public_path__ + "static/beatbugs-5b4930696ca4aff18bfc4aae272eaed1.svg";